function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import AppBar from "@mui/material/AppBar";
import { styled, useThemeProps } from "@mui/material/styles";
import { useLayoutCtx } from "../Root/Root";
import { CSS_TRANSITION } from "../utils/constant";
var OffsetRoot = styled("div")({
  flexShrink: 0
});

var Offset = (_ref) => {
  var _builder$element;

  var {
    element
  } = _ref;
  var {
    builder
  } = useLayoutCtx();
  return /*#__PURE__*/React.createElement(OffsetRoot, {
    className: "HeaderOffset",
    sx: {
      height: (_builder$element = builder[element]) === null || _builder$element === void 0 ? void 0 : _builder$element.getOffsetHeight()
    }
  });
};

var TopHeaderRoot = styled("div", {
  name: "AppTopHeader",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  zIndex: 1,
  transition: CSS_TRANSITION
});
export var TopHeader = (_ref2) => {
  var _builder$topHeader;

  var {
    children
  } = _ref2,
      inProps = _objectWithoutProperties(_ref2, ["children"]);

  var props = useThemeProps({
    props: inProps,
    name: "AppTopHeader"
  });
  var ctx = useLayoutCtx();
  var {
    builder
  } = ctx;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopHeaderRoot, _extends({}, props, {
    sx: _objectSpread(_objectSpread({}, props.sx), (_builder$topHeader = builder.topHeader) === null || _builder$topHeader === void 0 ? void 0 : _builder$topHeader.getSxProps())
  }), typeof children === "function" ? children(ctx) : children), /*#__PURE__*/React.createElement(Offset, {
    element: "topHeader"
  }));
};
var SubheaderRoot = styled("div", {
  name: "AppSubheader",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  zIndex: 1,
  transition: CSS_TRANSITION
});
export var Subheader = (_ref3) => {
  var _builder$subheader;

  var {
    children
  } = _ref3,
      inProps = _objectWithoutProperties(_ref3, ["children"]);

  var props = useThemeProps({
    props: inProps,
    name: "AppSubheader"
  });
  var ctx = useLayoutCtx();
  var {
    builder
  } = ctx;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubheaderRoot, _extends({}, props, {
    sx: _objectSpread(_objectSpread({}, props.sx), (_builder$subheader = builder.subheader) === null || _builder$subheader === void 0 ? void 0 : _builder$subheader.getSxProps())
  }), typeof children === "function" ? children(ctx) : children), /*#__PURE__*/React.createElement(Offset, {
    element: "subheader"
  }));
};
var HeaderRoot = styled(AppBar, {
  name: "AppHeader",
  slot: "Root",
  overridesResolver: (props, styles) => styles.root
})({
  transition: CSS_TRANSITION
});
export var Header = (_ref4) => {
  var _builder$header;

  var {
    children
  } = _ref4,
      inProps = _objectWithoutProperties(_ref4, ["children"]);

  var props = useThemeProps({
    props: inProps,
    name: "AppHeader"
  });
  var ctx = useLayoutCtx();
  var {
    builder
  } = ctx;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderRoot, _extends({
    color: "default",
    elevation: 0
  }, props, {
    sx: _objectSpread(_objectSpread({}, props.sx), (_builder$header = builder.header) === null || _builder$header === void 0 ? void 0 : _builder$header.getSxProps())
  }), typeof children === "function" ? children(ctx) : children), /*#__PURE__*/React.createElement(Offset, {
    element: "header"
  }));
};